import { render, staticRenderFns } from "./UpdateContactDetails.vue?vue&type=template&id=55cc170c&"
import script from "./UpdateContactDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports